import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sent-basket-overview-page',
    templateUrl: './sent-basket-overview-page.component.html',
    styleUrls: ['./sent-basket-overview-page.component.scss'],
    standalone: false
})
export class SentBasketOverviewPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
